export default {
  namespaced: true,
  state: {
    available: check(),
    data: {},
  },
  mutations: {
    setItem(state, { key, value }) {
      state.data[key] = value;

      if (state.available) {
        try {
          window.localStorage.setItem(key, value);
        } catch (e) {
          console.info(e.message);
        }
      }
    },
    removeItem(state, key) {
      delete state.data[key];

      if (state.available) {
        try {
          window.localStorage.removeItem(key);
        } catch (e) {
          console.info(e.message);
        }
      }
    },
  },
  getters: {
    getItem: state => (key) => {
      if (state.available && state.data[key] === undefined) {
        try {
          state.data[key] = window.localStorage.getItem(key);
        } catch (e) {
          console.info(e.message);
        }
      }

      return state.data[key];
    },
  },
};

function check() {
  try {
    // try to read from localStorage
    localStorage.getItem('any_random_item_kjdvbkhbvslvb');
    // if an exception wasn't threw, the localStorage is available
    return true;
  } catch (e) {
    console.info('localStorage is unavailable');
    return false;
  }
}
